import { createApi } from '@reduxjs/toolkit/query/react'
import { createPublicBinaryApiBaseQuery } from './apiClients'

export const fileApi = createApi({
    reducerPath: 'fileApi',
    baseQuery: createPublicBinaryApiBaseQuery('fileApi', { baseUrl: `${process.env.REACT_APP_API_BASE_URL}/files` }),
    endpoints: (builder) => ({
        getFile: builder.query({
            query: (args) => ({
                url: `/${args.userId}/${args.fileName}`,
                method: 'GET'
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status
        })
    }),
})

export const {
    useLazyGetFileQuery
} = fileApi
